// extracted by css-extract-rspack-plugin
export default {"label":"Terms_label__xr8-z","link":"Terms_link__AK06-"};